// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"merchant-slider_uk-open__ZcV16","grecaptcha-badge":"merchant-slider_grecaptcha-badge__6IO1C","root":"merchant-slider_root__rdfme","viewport":"merchant-slider_viewport__OsQS0","slider":"merchant-slider_slider__mFaTJ","merchant":"merchant-slider_merchant__t2xNT","dots":"merchant-slider_dots__E7Rdo","dot":"merchant-slider_dot__sG94c","activeDot":"merchant-slider_activeDot__LXD31","title":"merchant-slider_title__PldQn"};
    if(module.hot) {
      // 1751375820626
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  